import React from 'react';
import { BUSINESS } from '../config';

export default function MentionsLegales() {
  const L = BUSINESS.legal;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16" data-testid="mentions-legales-page">
      <h1 className="font-heading font-heading text-3xl uppercase tracking-tight text-primary mb-8">Mentions légales</h1>
      
      <div className="prose prose-slate max-w-none space-y-8 text-slate-700 text-sm leading-relaxed">
        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Éditeur du site</h2>
          <p>
            Le présent site, exploité sous l'enseigne <strong className="text-primary">{BUSINESS.name}</strong>, est édité par :
          </p>
          <p className="mt-3">
            <strong className="text-primary">{L.raisonSociale}</strong> — {L.formeJuridique} au capital de {L.capital}<br />
            Siège social : {L.siege}<br />
            {L.rcs} — SIRET : {L.siret}<br />
            TVA intracommunautaire : {L.tva}<br />
            Code APE : {L.ape}<br />
            Téléphone : {BUSINESS.telephone}<br />
            Boutique : {BUSINESS.adresse}<br />
            Directeur de la publication : {L.directeurPublication}
          </p>
        </section>

        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Hébergement</h2>
          <p>{BUSINESS.hebergeur}</p>
        </section>

        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Activité</h2>
          <p>
            {BUSINESS.name} est une boutique de vente de matériel informatique (PC reconditionnés, PC neufs, accessoires) située à {BUSINESS.ville} ({BUSINESS.codePostal}).
          </p>
        </section>

        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Propriété intellectuelle</h2>
          <p>
            L'ensemble des contenus (textes, images, logos) présents sur ce site sont la propriété exclusive de {BUSINESS.name}, sauf mention contraire. Toute reproduction est interdite sans autorisation préalable.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Responsabilité</h2>
          <p>
            Les informations fournies sur ce site le sont à titre indicatif. {BUSINESS.name} s'efforce de maintenir les prix et la disponibilité à jour, mais ne saurait être tenu responsable d'éventuelles erreurs ou omissions. La réservation en ligne ne constitue pas un achat. Le paiement se fait exclusivement en boutique.
          </p>
        </section>
      </div>
    </div>
  );
}
